<template>
  <div class="dialog-footer flex-row justify-end gap-3">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.dialog-footer {
  padding: 24px;
  border-top: 0.5px solid var(--divider);
}
</style>
